<template>
  <div class="dt-group-btn">
    <div class="dt-group-btn-func row">
      <div class="last-action col-md-6" @click="showHistory()"><span v-if="item.lastModifiedByUserName">Last {{ lastUpdateText
        }} by {{ item.lastModifiedByUserName
        }} at {{ item.lastModifiedAt | formatLastUpdate }}</span>
      </div>
      <div class="grp-button-action col-md-6" v-if="showGrpBtn">
        <div class="button-action-container">
          <div class="outer">
            <div class="middle" v-if="isAdminButton">
              <div class="inner" @click="isShowAction = true" @mouseleave="isShowAction = false">
                <Icon class="admin-func-icon" name="ellipsis-v"></Icon>
                <ul class="action-panel" v-if="isShowAction">
                  <li @click="editEvent()">Edit</li>
                  <li v-if="eventStatus != 'drafts'" @click="moveEvent(item.id, item.eventName, 'Drafts')">Move to <span
                    class="semi-bold">Drafts</span>
                  </li>
                  <li v-if="eventStatus != 'submitted'" @click="moveEvent(item.id, item.eventName, 'Submitted')">Move to <span
                    class="semi-bold">Submitted to ADURO</span></li>
                  <li v-if="eventStatus != 'review'" @click="moveEvent(item.id, item.eventName, 'Review')">Move to <span
                    class="semi-bold">Needs Review</span>
                  </li>
                  <li v-if="eventStatus != 'approved'" @click="moveEvent(item.id, item.eventName, 'Approved')">Move to <span
                    class="semi-bold">Approved</span></li>
                  <li v-if="eventStatus != 'archived'" @click="moveEvent(item.id, item.eventName, 'Archived')">Move to <span
                    class="semi-bold">Archived</span></li>
                  <li v-if="eventStatus != 'deleted'" @click="deleteEventClick()"><span class="semi-bold">Delete event</span>
                  </li>
                </ul>
              </div>
            </div>
            <b-button v-if="isEnableBtnLeft" class="dt-group-btn-func-btn-left" @click="btnLeftClick()">
              <span class="dt-group-btn-func-btn-left-text">{{groupButtonFunc.btnLeft}}</span>
            </b-button>
            <b-button v-if="isEnableBtnRight || isLocked" class="dt-group-btn-func-btn-right"
                      @click="dispatchFunc()">
              <div v-if="isCircle" class="oval-background">
                <Icon v-if="groupButtonFunc.btnRightIcon != ''" :name="groupButtonFunc.btnRightIcon"
                      class="func-icon"></Icon>
              </div>
              <span v-if="!isCircle">
                <Icon v-if="groupButtonFunc.btnRightIcon != ''" :name="groupButtonFunc.btnRightIcon"
                      class="func-icon"></Icon>
              </span>
              <div v-if="isCircle && !showRelatedEvent"
                   class="dt-group-btn-func-btn-right-text dt-group-btn-func-btn-right-text-width"> {{ btnRightText
                }}
              </div>
              <div v-if="isCircle && showRelatedEvent" class="dt-group-btn-func-btn-right-text"> {{ btnRightText }}
              </div>
              <div v-if="!isCircle" class="dt-group-btn-func-btn-right-text"
                   :class="{ 'no-margin-left' : (btnRightText === 'Request Change' || btnRightText === 'Go to event' || btnRightText === 'Save') }">
                {{ btnRightText }}
              </div>
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import 'vue-awesome/icons/arrow-circle-o-right';
  import 'vue-awesome/icons/ellipsis-v';
  import constants from '../../_consts';
  import Icon from 'vue-awesome/components/Icon';
  import Vue from 'vue';
  import moment from 'moment';
  import routerConstanst from '@/router/constants';
  import {mapGetters, mapActions} from 'vuex';
  const _ = require('lodash');

  Vue.filter('formatLastUpdate', function (value) {
    if (value) {
      let time = new Date(value);
      return moment(String(time)).format('h:mm A MM/DD/YYYY');
    }
  });

  export default {
    name: 'DtGroupBtn',
    components: {
      Icon
    },
    data () {
      return {
        isShowAction: false,
        groupButtonFunc: {},
        userRole: '',
        isCircle: false
      };
    },
    props: {
      item: {
        type: Object,
        default: {}
      },
      eventStatus: {
        type: String,
        default: ''
      },
      isSuggestChanges: {
        type: Boolean,
        default: false
      },
      viewMode: {
        type: String,
        default: 'Client'
      },
      showOnModal: {
        type: Boolean,
        default: false
      },
      isLocked: {
        type: Boolean,
        default: false
      },
      editEventAdmin: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      btnRightText: function () {
        if (this.isSuggestChanges === false) {
          return this.showRelatedEvent ? this.groupButtonFunc.btnRightRelated : this.groupButtonFunc.btnRight
        }
        return this.groupButtonFunc.btnRight;
      },
      isEnableBtnLeft: function () {
        return !!(this.groupButtonFunc.btnLeft !== '' && this.isEnableBtnRight);
      },
      isAdminButton: function () {
        return this.userRole === constants.USER_ROLE.admin;
      },
      isEnableBtnRight: function () {
        let getRole = localStorage.getItem(constants.LOCAL_STORE.role);
        if (this.groupButtonFunc.btnRight !== '' && this.groupButtonFunc.btnRight !== undefined) {
          if (this.eventStatus === constants.eventStatus.drafts) {
            return true;
          }
          if (this.eventStatus === constants.eventStatus.submitted) {
            return getRole === constants.USER_ROLE.eventManager || getRole === constants.USER_ROLE.admin;
          }
        }
        if (this.groupButtonFunc.btnRight !== '' && this.groupButtonFunc.btnRight !== undefined) {
          return true;
        }
        return this.showOnModal === true;
      },
      lastUpdateText: function () {
        return this.groupButtonFunc.lastUpdateText || '';
      },
      funcBtnIcon: function () {
        return this.groupButtonFunc.funcBtnIcon || '';
      },
      showGrpBtn () {
        let readOnly = localStorage.getItem(constants.LOCAL_STORE.readOnly) === 'true';
        // let isClientManager = localStorage.getItem(constants.USER_ROLE.readOnly) === constants.USER_ROLE.clientManager;
        let isDrafts = this.eventStatus.toLowerCase() === constants.eventStatus.drafts.toLowerCase();
        return isDrafts || !readOnly;
      },
      ...mapGetters({
        showRelatedEvent: 'GETTERS_SHOW_RELATED_EVENT'
      })
    },
    methods: {
      btnLeftClick () {
        if (this.groupButtonFunc.action === constants.modalAction.editEvent) {
          this.$modal.hide('ModalEditEvent');
        } else {
          this.setExpandId({id: -1, isExpand: false});
          if (this.showRelatedEvent === true) {
            this.restoreListEvent();
            this.setShowRelatedEvents(false);
          }
        }
      },
      dispatchFunc () {
        // Go to event
        if (this.userRole !== constants.USER_ROLE.client && this.viewMode !== 'Client') {
          let clientItem = {
            id: this.item.clientId,
            clientName: this.item.clientName
          };
          this.selectClient(clientItem);
          this.$router.push({
            name: routerConstanst.clientDashboard.name,
            params: {
              clientId: clientItem.id
            }
          });
          return;
        }
        // save event
        if (this.groupButtonFunc.action === constants.modalAction.saveEvent && !this.isLocked) {
          this.updateEvent(this.item);
          this.setExpandId({id: -1, isExpand: false});
        }
        // Approve event
        if (this.groupButtonFunc.action === constants.modalAction.approveEvent) {
          if (!this.showRelatedEvent) {
            this.setItemRelated(this.item);
          } else {
            // for show approve modal
            let modalData = {
              action: constants.modalAction.approveEvent,
              data: this.item
            };
            this.$modal.show('eventModal', modalData);
          }
        }
        // Change order event, event move from Approved folder => Drafts folder
        if (this.groupButtonFunc.action === constants.modalAction.changeOrderDetail) {
          if (this.item.additionalComments === '') {
            Vue.prototype.$toastr('error', 'Additional Comments is required!', '');
            return;
          }
          this.item.status = constants.eventStatus.drafts.toUpperCase();
          this.item.isChangeOrder = true;
          if (this.item.projPart >= 34) {
            this.item.addOns = this.item.addOns.replace('smallSiteModel', '');
            this.item.addOns = this.item.addOns.replace('smallSiteConcierge', '');
          }
          this.submitEvent(this.item);
          let modalData = {
            action: constants.modalAction.showInfo,
            data: null
          };
          this.$modal.show('eventModal', modalData);
          this.$modal.hide('ModalChangeOrder');
        }
        if (this.groupButtonFunc.action === constants.modalAction.editEvent) {
          this.updateEvent(this.item);
          this.$modal.hide('ModalEditEvent');
        }
      },
      showHistory () {
        let getRole = localStorage.getItem(constants.LOCAL_STORE.role);
        let role = (getRole === constants.USER_ROLE.admin) || (getRole === constants.USER_ROLE.eventManager);
        if (this.item.status !== constants.eventStatus.drafts.toUpperCase() && role) {
          this.getEventHistory(this.item.id);
          this.$modal.show('historyModal');
        }
      },
      moveEvent (eventId, eventName, eventStatus) {
        let modalData = {
          action: constants.modalAction.moveEvent,
          data: {
            eventId: eventId,
            eventName: eventName,
            updateStatus: eventStatus
          }
        };
        this.$modal.show('eventModal', modalData);
      },
      deleteEventClick () {
        let modalData = {
          action: constants.modalAction.deleteEvent,
          data: this.item
        };
        this.$modal.show('eventModal', modalData);
      },
      editEvent () {
        let event = _.cloneDeep(this.item);

        let data = {
          action: constants.modalAction.editEvent,
          data: event
        };
        this.$modal.show('ModalEditEvent', data);
      },
      ...mapActions({
        submitEvent: 'ACTION_SUBMIT_EVENT',
        updateEvent: 'ACTION_UPDATE_EVENT',
        resetExpandId: 'ACTION_RESET_EXPAND_ID',
        setItemRelated: 'ACTION_SET_ITEM_RELATED',
        setListBack: 'ACTION_SET_LIST_BACK',
        setExpandId: 'ACTION_SET_EXPAND_ID',
        selectClient: 'ACTION_SELECT_CLIENT',
        restoreListEvent: 'ACTION_RESTORE_LIST_EVENT',
        setShowRelatedEvents: 'ACTION_SET_SHOW_RELATED_EVENT',
        getEventHistory: 'ACTION_GET_EVENT_HISTORY'
      })
    },
    mounted: function () {
      if (this.editEventAdmin) {
        this.groupButtonFunc = constants.EVENT_TYPES.editEventAdmin;
        return;
      }
      if (this.showOnModal) {
        this.groupButtonFunc = constants.EVENT_TYPES.changeOrderDetail;
        return;
      }
      this.userRole = localStorage.getItem(constants.LOCAL_STORE.role);
      if (this.userRole === constants.USER_ROLE.eventManager || this.userRole === constants.USER_ROLE.admin) { // EM button
        if (this.viewMode !== 'Client') { // View in mode manager => Go to event
          this.groupButtonFunc = constants.EVENT_TYPES.eventManager.magagerOverview;
        } else { // view in mode client = Suggest changes, Approve
          if (this.eventStatus === constants.eventStatus.drafts) {
            this.groupButtonFunc = constants.EVENT_TYPES[this.eventStatus];
          }
          if (this.eventStatus === constants.eventStatus.submitted) {
            this.groupButtonFunc = this.isSuggestChanges ? constants.EVENT_TYPES[this.eventStatus].suggestChanges : constants.EVENT_TYPES[this.eventStatus].approve;
          }
        }
      } else { // AM or Client
        if (this.viewMode !== 'Client') { // View in mode manager => Go to event
          this.groupButtonFunc = constants.EVENT_TYPES.eventManager.magagerOverview;
        } else {
          if (this.eventStatus === constants.eventStatus.drafts) {
            this.groupButtonFunc = constants.EVENT_TYPES[this.eventStatus];
          }
          if (this.eventStatus === constants.eventStatus.review) {
            this.groupButtonFunc = this.isSuggestChanges ? constants.EVENT_TYPES[this.eventStatus].suggestChanges : constants.EVENT_TYPES[this.eventStatus].resubmit;
          }
        }
      }
    },
    watch: {
      isSuggestChanges: function () {
        if (this.eventStatus === constants.eventStatus.submitted) {
          this.groupButtonFunc = this.isSuggestChanges ? constants.EVENT_TYPES[this.eventStatus].suggestChanges : constants.EVENT_TYPES[this.eventStatus].resubmit;
        }
        if (this.eventStatus === constants.eventStatus.submitted) {
          this.groupButtonFunc = this.isSuggestChanges ? constants.EVENT_TYPES[this.eventStatus].suggestChanges : constants.EVENT_TYPES[this.eventStatus].approve;
        }
      },
      groupButtonFunc: {
        handler: function (groupButtonFunc) {
          this.isCircle = this.groupButtonFunc.btnRightIcon === 'angle-right';
        },
        deep: true
      }
    }
  }
</script>

<style lang="less">
  @import '../../styles/variables.less';

  .dt-group-btn {
    margin: 15px 0 0 5px;
    .dt-group-btn-func {
      .last-action {
        text-transform: uppercase;
        color: @black-1;
        font-family: @font-family-main;
        font-size: 12px;
        padding-top: 22px;
        &:hover {
          cursor: pointer;
        }
      }
      .grp-button-action {
        text-align: right;
        padding-right: 25px;
        .dt-group-btn-func-btn-left {
          height: 37px;
          width: auto;
          border: 1px solid @blue;
          border-radius: 4px;
          background-color: @white;
          .dt-group-btn-func-btn-left-text {
            color: @blue;
            font-family: @font-family-main;
            font-size: 12px;
            font-weight: 600;
            line-height: 17px;
          }
        }
        .dt-group-btn-func-btn-right {
          height: 37px;
          width: auto;
          border-radius: 4px;
          background-color: @light-blue;
          margin-left: 10px;
          .dt-group-btn-func-btn-right-text {
            color: @white;
            font-family: @font-family-main;
            font-size: 12px;
            font-weight: 600;
            line-height: 17px;
            margin-top: 1px;
            margin-left: 25px;
            margin-right: 3px;
          }
          .dt-group-btn-func-btn-right-text-width {
            line-height: 17px;
            // width: 165px;
            margin: 0 0 0 32px;
            // margin-left: 32px;
          }
          .no-margin-left {
            margin-left: 0;
          }
        }
        .oval-background {
          box-sizing: border-box;
          border: 2px solid @white;
          border-radius: 50px;
          width: 25px;
          height: 25px;
          margin-right: 7px;
          float: left;
          margin-top: -3px;
        }
      }
    }
    .button-action-container {
      .outer {
        display: table;
        height: 100%;
        float: right;
        .middle {
          display: table-cell;
          vertical-align: middle;
          .inner {
            margin-left: auto;
            margin-right: auto;
            font-size: 45px;
            line-height: 30px;
            text-align: center;
            position: relative;
            .admin-func-icon {
              height: 30px;
              width: 24px;
              color: #00A4D6;
              &:hover {
                cursor: pointer;
              }
            }
            ul.action-panel {
              list-style: none;
              font-size: 15px;
              text-align: left;
              padding: 15px;
              margin-bottom: 0;
              border-radius: 3px;
              background-color: #FFFFFF;
              box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);
              position: absolute;
              bottom: 5px;
              right: 20px;
              width: 255px;
              li {
                padding-left: 10px;
                border-bottom: solid 1px #E6E6E6;
                &:last-child {
                  border-bottom: none;
                }
                &:hover {
                  cursor: pointer;
                  background-color: #F5F5F5
                }
                .semi-bold {
                  font-weight: 500;
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// DataTableGroupBtn.vue?08492216